import { useStatisticsPageErrorContext } from "./StatisticsPageErrorContext";

export function normalizeStatisticsWidgetError(error: unknown): string | null {
  if (error == null) return null;
  if (typeof error === "string") return error.trim() || null;
  if (error instanceof Error) return error.message.trim() || null;
  return String(error).trim() || null;
}

/** When the Statistics page banner is active, hide per-widget error UI. */
export function useStatisticsWidgetErrorGate(
  error: unknown,
  errorAction?: string | null
): {
  showWidgetError: boolean;
  widgetError: string | null;
  widgetAction: string | null;
} {
  const { suppressWidgetErrors } = useStatisticsPageErrorContext();
  const widgetError = normalizeStatisticsWidgetError(error);
  const widgetAction = errorAction?.trim() || null;
  return {
    showWidgetError: Boolean(widgetError) && !suppressWidgetErrors,
    widgetError,
    widgetAction,
  };
}
